import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSeriesTerms } from '../series';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ModalWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 353px;
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 10px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  padding: 40px 32px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.55);
`;

const ModalClose = styled.button`
  position: absolute;
  top: -17px;
  right: -4px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1.5px solid #2d2d2d;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 101;
  padding: 0;
`;

const Title = styled.h2`
  font-family: 'Speedee Bold';
  font-size: 24px;
  color: #2d2d2d;
  text-align: center;
  margin: 0 0 16px;
  line-height: 1.1;
`;

const Body = styled.div`
  font-family: 'Speedee Regular';
  font-size: 16px;
  color: #4a4a4a;
  line-height: 1.5;

  strong {
    font-family: 'Speedee Bold';
    color: #2d2d2d;
  }

  p {
    margin: 0 0 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

function TermsModal({ onClose }) {
  const terms = useSeriesTerms();

  useEffect(() => {
    // trackPageView('terms');

    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <ModalOverlay
      onClick={() => {
        onClose();
        window.gtag('event', 'mm-termsconditions-tap-outside');
      }}>
      <ModalWrapper onClick={(e) => e.stopPropagation()}>
        <ModalClose
          onClick={() => {
            onClose();
            window.gtag('event', 'mm-termsconditions-btn-close');
          }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 5L15 15M15 5L5 15" stroke="#2D2D2D" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </ModalClose>
        <ModalContent>
          <Title>Terms & Conditions</Title>
          <Body>
            {terms === undefined ? null : terms ? (
              terms.split(/\n\s*\n/).map((paragraph, i) => <p key={i}>{paragraph}</p>)
            ) : (
              <p>Terms & Conditions are currently unavailable. Please try again later.</p>
            )}
          </Body>
        </ModalContent>
      </ModalWrapper>
    </ModalOverlay>
  );
}

export default TermsModal;
